import * as React from 'react';

import Filter from '../../../../../models/Filter';
import { ChipsContainer, ClearAllButton } from './ChipsRow.styles';

interface ChipsRowProps {
  filters: Array<Filter>;
  onClear: () => void;
}

const ChipsRow = ({ filters, onClear }: ChipsRowProps) => {
  // Helpers
  const renderChipsValues = () => {
    return filters.map((filter) => {
      return filter.getChips();
    });
  };

  return (
    <ChipsContainer>
      {renderChipsValues()}
      {filters?.length > 0 && <ClearAllButton onPress={() => onClear()}>{'Clear all'}</ClearAllButton>}
    </ChipsContainer>
  );
};

export default ChipsRow;
